import { PropTypes } from 'prop-types';
import React, {
  useState, useEffect,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate } from '@Apis/constants';
import {
  Button,
  Divider,
  Drawer, Select, Table, Tag, Tooltip,
} from 'antd';
import H3DateSelector from '@Uilib/h3DateSelector';
import { FilterOutlined, InfoCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import { v4 as uuidv4 } from 'uuid';
import PRZText from '../../../Common/UI/PRZText';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';

const { Option } = Select;

const TallyMappedDocuments = ({
  user, history, currentDocumentState, getTallyDocuments, tallyDocuments, getTallyDocumentsLoading, currentTab, syncTallyDocumentsLoading,
  syncTallyDocuments, updateTallyDocumentsLoading, updateTallyDocuments, getTallyDocumentsCount, getTallyDocumentsCountLoading, counter, MONEY, isConnected, showDrawer,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [selectedTenantIds, setSelectedTenantIds] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [call, setCall] = useState(false);
  const [limit, setLimit] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [entityName, setEntityName] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const getTallyColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={record?.entity_name === 'invoice' ? `/sales/invoice/view/${record?.entity_id}`
                //   : (record?.entity_name === 'credit_note' ? `/sales/credit-note/view/${record?.entity_id}` : `/purchase/goods-receiving/view/${record?.entity_id}`)}
                // target="_blank"
                >
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.entity_number ? record.entity_number : 'N/A'}`} />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ color: Helpers.getStatusColor(record.status).color }}
                  text={record?.status?.replaceAll('_', ' ')?.toProperCase() || '-'}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Tooltip
                    title={(
                      <Link
                        // to={
                        //   (record?.entity_name === 'invoice' || record?.entity_name === 'credit_note') ? `/sales/customer/view/${record?.party_ledger_id}`
                        //     : `/vendors/view/${record?.party_ledger_id}`
                        // }
                        // target="_blank"
                      >
                        <PRZText
                          className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                          text={`${record?.party_ledger_info?.customer_name || record?.party_ledger_info?.seller_name || ''}`}
                        />
                      </Link>
                    )}
                    color="white"
                  >
                    <PRZText
                      className="mobile-list__card_item-name"
                      text={`${record?.party_ledger_info?.customer_name || record?.party_ledger_info?.seller_name || ''}`}
                    />
                  </Tooltip>
                </div>
                <PRZText
                  text={`Location - ${record?.entity_location}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`${(currentDocumentState === 'ERROR' || currentDocumentState === 'COMPLETED') ? 'Tally Updated At' : 'Created Date'} - ${(currentDocumentState === 'ERROR' || currentDocumentState === 'COMPLETED') ? record?.tally_updated_at
                    ? toISTDate(record.tally_updated_at).format('MMM DD, YYYY hh:mm A')
                    : '' : toISTDate(record?.created_at || '').format('MMM DD, YYYY')}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Document Date - ${toISTDate(record?.entity_date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={record?.entity_name?.toProperCase()?.replaceAll('_', ' ')}
                    />
                  )}
                  color="white"
                >
                  <PRZText
                    text={`Document Type - ${record?.entity_name?.toProperCase()?.replaceAll('_', ' ')}`}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text="Ledger Total"
                    />
                  )}
                  color="white"
                >
                  <PRZText
                    text={`${MONEY(record?.document_grand_total) || ''}`}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                {
                  currentDocumentState === 'ERROR' && (
                    <Tooltip
                      title={(
                        <PRZText
                          className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                          text={`Error - ${record?.tally_warning_message || ''}`}
                        />
                      )}
                      color="white"
                    >
                      <PRZText
                        style={{
                          color: 'black',
                        }}
                        className="mobile-list__card_footer__other-status"
                        text={`${record?.tally_warning_message || ''}`}
                      />
                    </Tooltip>
                  )
                }
              </div>
              <div className="mobile-list__card_footer-right">
                <div />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'Location',
        render: (record) => (
          <div>
            <H3Text text={record?.entity_location} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Document Type',
        render: (record) => {
          const sourceDifferent = record?.entity_name !== record?.source;
          return (
            <div>
              <H3Text text={record?.entity_name?.toProperCase()?.replaceAll('_', ' ')} />
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Document',
        render: (record) => (
          <div className="associated-entity">
            <Link
              to={record?.entity_name === 'invoice' ? `/sales/invoice/view/${record?.entity_id}`
                : (record?.entity_name === 'credit_note' ? `/sales/credit-note/view/${record?.entity_id}` : (record?.entity_name === 'debit_note' ? `/purchase/debit-note/view/${record?.entity_id}` : `/purchase/goods-receiving/view/${record?.entity_id}`))}
              target="_blank"
            >
              {record?.entity_number}
            </Link>
          </div>

        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Status',
        render: (record) => (
          <div style={{ color: Helpers.getStatusColor(record?.status).color }}>
            {record?.status?.replaceAll('_', ' ') || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Party Name',
        render: (record) => (
          <div className="associated-entity">
            <Link
              to={
                (record?.entity_name === 'invoice' || record?.entity_name === 'credit_note') ? `/sales/customer/view/${record?.party_ledger_id}`
                  : `/vendors/view/${record?.party_ledger_id}`
              }
              target="_blank"
            >
              <H3Text text={`${record?.party_ledger_info?.customer_name || record?.party_ledger_info?.seller_name || ''}`} />
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Ledger Total',
        render: (record) => (
          <div className="column-amount">
            <H3Text text={`${MONEY(record?.document_grand_total || '')}`} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: (currentDocumentState === 'ERROR' || currentDocumentState === 'COMPLETED') ? 'Tally Updated At' : 'Created Date',
        render: (record) => (
          <div className="column-date">
            <H3Text text={(currentDocumentState === 'ERROR' || currentDocumentState === 'COMPLETED') ? record?.tally_updated_at
              ? toISTDate(record.tally_updated_at).format('MMM DD, YYYY hh:mm A')
              : '' : toISTDate(record?.created_at || '').format('MMM DD, YYYY')}
            />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Document Date',
        render: (record) => (
          <div className="column-date">
            <H3Text text={toISTDate(record.entity_date).format('MMM DD, YYYY')} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
    ];
    if (currentDocumentState === 'ERROR') {
      columns.push({
        title: 'Error',
        render: (record) => (
          <div className="column-error__wrapper">
            <H3Text text={`${record?.tally_warning_message || ''}`} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      });
    }
    return columns.filter((item) => !item.hidden);
  };

  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: uuidv4() }));
    }
    return [];
  };
  const handleSync = (rows) => {
    const grnIds = rows?.filter((row) => row.entity_name === 'good_receiving_note').map((row) => row.entity_id);
    const invoiceIds = rows?.filter((row) => row.entity_name === 'invoice').map((row) => row.entity_id);
    const creditNoteIds = rows?.filter((row) => row.entity_name === 'credit_note').map((row) => row.entity_id);
    const debitNoteIds = rows?.filter((row) => row.entity_name === 'debit_note').map((row) => row.entity_id);
    if (grnIds?.length > 0 || invoiceIds?.length > 0 || creditNoteIds?.length > 0 || debitNoteIds?.length > 0) {
      const payload = {
        grn_ids: grnIds,
        invoice_ids: invoiceIds,
        cn_ids: creditNoteIds,
        dn_ids: debitNoteIds,
      };
      syncTallyDocuments(payload, () => {
        setSelectedRowKeys(null);
        setSelectedRows([]);
        setCall(!call);
      });
    }
  };

  const handleExcludeDocuments = (rows) => {
    const grnIds = rows?.filter((row) => row.entity_name === 'good_receiving_note').map((row) => row.entity_id);
    const invoiceIds = rows?.filter((row) => row.entity_name === 'invoice').map((row) => row.entity_id);
    const creditNoteIds = rows?.filter((row) => row.entity_name === 'credit_note').map((row) => row.entity_id);
    const debitNoteIds = rows?.filter((row) => row.entity_name === 'debit_note').map((row) => row.entity_id);
    if (grnIds?.length > 0 || invoiceIds?.length > 0 || creditNoteIds?.length > 0 || debitNoteIds?.length > 0) {
      const payload = {
        grn_ids: grnIds,
        invoice_ids: invoiceIds,
        cn_ids: creditNoteIds,
        dn_ids: debitNoteIds,
        required_tally_sync: currentDocumentState === 'PENDING',
      };
      updateTallyDocuments(payload, () => {
        setSelectedRowKeys(null);
        setSelectedRows([]);
        setCall(!call);
      });
    }
  };
  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      setSelectedTenantIds((Helpers.getValueFromUrl('tenant')?.split(',')?.length > 1 ? 'All' : Number(Helpers.getValueFromUrl('tenant'))) || user?.tenant_info?.tenant_id);
      setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      setStartDate(Number(Helpers.getValueFromUrl('from_date')));
      setEndDate(Number(Helpers.getValueFromUrl('to_date')));
      setIsUserReady(true);
    }
  }, []);

  useEffect(() => {
    if (isUserReady || !showDrawer) {
      getTallyDocumentsCount(user?.tenant_info?.tenant_id, (data) => {
        counter({
          unMappedCount: data?.unmapped_count,
          readyToPushCount: data?.ready_to_push_count,
          completedCount: data?.completed_count,
          errorCount: data?.error_count,
          excludedDocCount: data?.exclude_document_count,
        });
      });
      getTallyDocuments(selectedTenant || user?.tenant_info?.tenant_id, currentDocumentState, startDate, endDate, currentPage, limit, entityName, (_data) => {
        if (currentDocumentState === 'PENDING') {
          counter((prevCounter) => ({
            ...prevCounter,
            readyToPushCount: _data?.count,
          }));
        }
        if (currentDocumentState === 'COMPLETED') {
          counter((prevCounter) => ({
            ...prevCounter,
            completedCount: _data?.count,
          }));
        }
        if (currentDocumentState === 'ERROR') {
          counter((prevCounter) => ({
            ...prevCounter,
            errorCount: _data?.count,
          }));
        }
        if (currentDocumentState === 'EXCLUDE') {
          counter((prevCounter) => ({
            ...prevCounter,
            excludedDocCount: _data?.count,
          }));
        }
      });
      setIsUserReady(false);
    }
  }, [currentPage, searchKeyword, selectedTenant, startDate, endDate, call, currentDocumentState, currentTab, limit, entityName, showDrawer]);

  return (
    <div>
      <div className="doc-list__wrapper doc-list__tab-content">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper" />
            <div className="header__tags">
              {
                (startDate && endDate) ? (
                  <Tag
                    closable
                    onClose={() => {
                      setStartDate(null);
                      setEndDate(null);
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    From:
                    &nbsp;
                    <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To:
                    &nbsp;
                    <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                ) : ''
              }
              {selectedTenant && selectedTenant?.map((item) => (
                <Tag
                  key={item}
                  closable
                  onClose={() => {
                    setCurrentPage(1);
                    setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                  }}
                  color="#2d7df7"
                >
                  Business Unit -
                  &nbsp;
                  <span>
                    <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                  </span>
                </Tag>
              ))}
              {entityName && (
                <Tag
                  closable
                  onClose={() => {
                    setCurrentPage(1);
                    setEntityName('');
                  }}
                  color="#2d7df7"
                >
                  Document Type -
                  &nbsp;
                  <span>
                    <b>{entityName?.split('_')?.join(' ')?.toUpperCase()}</b>
                  </span>
                </Tag>
              )}
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(tallyDocuments && tallyDocuments?.count) ? tallyDocuments?.count : '0'} Documents`} className="" />
                    </div>
                    <div className="doc-list__table-header__right tally__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <H3DateSelector
                          startDate={startDate}
                          endDate={endDate}
                          onDateChange={(date) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                          }}
                        />
                      </div>
                      <div className="doc-list__action-buttons" onClick={() => setShowFilters(true)}>
                        <div className="action-button">
                          <H3Text text="Filters" className="action-button-text" />
                          <FilterOutlined />
                        </div>
                      </div>
                      <Button
                        className="move-button hide__in-mobile"
                        type="primary"
                        onClick={() => handleExcludeDocuments(selectedRows)}
                        loading={updateTallyDocumentsLoading}
                        disabled={
                          updateTallyDocumentsLoading
                          || getTallyDocumentsCountLoading
                          || getTallyDocumentsLoading
                          || !(selectedRows?.length > 0 && (currentDocumentState === 'PENDING' || currentDocumentState === 'EXCLUDE'))
                        }
                        size="small"
                      >
                        {currentDocumentState === 'PENDING' ? 'Move to Exclude List' : 'Move to Ready List'}
                      </Button>
                      {currentDocumentState !== 'EXCLUDE' && (
                        <div className="sync-button__wrapper hide__in-mobile">
                          <Button
                            className="sync-button"
                            type="primary"
                            onClick={() => handleSync(selectedRows)}
                            loading={syncTallyDocumentsLoading}
                            disabled={updateTallyDocumentsLoading || getTallyDocumentsCountLoading || getTallyDocumentsLoading || !isConnected || !selectedRows?.length > 0}
                            size="small"
                          >
                            Sync with Tally
                          </Button>
                          <Tooltip title="Make sure to open tally connector and tally app before pushing the documents">
                            <InfoCircleOutlined />
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                loading={getTallyDocumentsLoading || getTallyDocumentsCountLoading || syncTallyDocumentsLoading || updateTallyDocumentsLoading}
                showHeader
                size="small"
                scroll={{ x: 'max-content' }}
                columns={getTallyColumns()}
                dataSource={getDataSource(tallyDocuments?.data || [])}
                rowKey="entity_number"
                pagination={{
                  defaultCurrent: currentPage,
                  current: currentPage,
                  total: tallyDocuments ? tallyDocuments?.count : 0,
                  pageSize: limit,
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setLimit(pageSize);
                    setSelectedRows([]);
                    setSelectedRowKeys(null);
                  },
                  position: ['bottomLeft'],
                  showSizeChanger: true,
                  pageSizeOptions: [10, 25, 50, 100],
                }}
                rowSelection={!isMobileOrPortrait ? {
                  onChange: (rowKeys, rows) => {
                    setSelectedRowKeys(rowKeys);
                    setSelectedRows(rows);
                  },
                  selectedRowKeys,
                } : false}
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showFilters}
        width="340px"
        mask
        onClose={() => setShowFilters(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '295px' }}>
            <H3Text text="Apply Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowFilters(false)} />
          </div>
        </div>
        <div className="filter-drawer__wrapper">
          <div className="filter__container">
            <div className="filter__title"> Select Business Unit </div>
            <TenantSelector
              selectedTenant={selectedTenant}
              showSearch
              onChange={(value) => {
                setSelectedTenant(value);
              }}
              placeholder="Select Business Unit"
              isMultiple
              hideTitle
              includedTenants={Helpers.getTallyAllowedTenants(user?.user_tenants, user.tenant_info?.tally_configuration?.it_id)}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Document Type </div>
            <PRZSelect
              maxTagCount="responsive"
              value={entityName}
              onChange={(value) => {
                setEntityName(value);
                setCurrentPage(1);
              }}
              placeholder="Filter Documents By Name"
            >
              <Option key="GOOD_RECEIVING_NOTE" value="good_receiving_note">GOOD RECEIVING NOTE</Option>
              <Option key="INVOICE" value="invoice">INVOICE</Option>
              <Option key="CREDIT_NOTE" value="credit_note">CREDIT NOTE</Option>
              {/* <Option key="DEBIT_NOTE" value="debit_note">DEBIT NOTE</Option> */}
            </PRZSelect>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TallyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  tallyDocuments: TallyIntegrationReducers.tallyDocuments,
  getTallyDocumentsLoading: TallyIntegrationReducers.getTallyDocumentsLoading,
  syncTallyDocumentsLoading: TallyIntegrationReducers.syncTallyDocumentsLoading,
  updateTallyDocumentsLoading: TallyIntegrationReducers.updateTallyDocumentsLoading,
  getTallyDocumentsCountLoading: TallyIntegrationReducers.getTallyDocumentsCountLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getTallyDocuments: (tenantIds, documentType, startDate, endDate, page, limit, entityName, callback) => dispatch(TallyIntegrationActions.getTallyDocuments(tenantIds, documentType, startDate, endDate, page, limit, entityName, callback)),
  syncTallyDocuments: (payload, callback) => dispatch(TallyIntegrationActions.syncTallyDocuments(payload, callback)),
  updateTallyDocuments: (payload, callback) => dispatch(TallyIntegrationActions.updateTallyDocuments(payload, callback)),
  getTallyDocumentsCount: (tenantIds, callback) => dispatch(TallyIntegrationActions.getTallyDocumentsCount(tenantIds, callback)),
});

TallyMappedDocuments.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyMappedDocuments));
